import CryptoJS from 'crypto-js'

const SECRET_KEY = 'ID-fleetAdmin@$#'

export const encryptData = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString()
  return ciphertext
}

export const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY)
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  return decryptedData
}
export const getDecryptedSessionStorageVariable = (variableName) => {
  const encryptedValue = sessionStorage.getItem(variableName)

  if (!encryptedValue) {
    return null
  }

  try {
    const decryptedValue = decryptData(encryptedValue)
    return decryptedValue
  } catch (error) {
    console.error(`Error decrypting ${variableName}:`, error)
    return encryptedValue
  }
}
